var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map_container",attrs:{"id":"map_container"}},[(_vm.loading)?_c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"loader"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }